module.exports = __webpack_public_path__ + "img/0Q3A0072_L_Foamcore.ca1f893b.jpg";